var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.groupe)?_c('groupe-form',{attrs:{"initial-groupe":_vm.groupe}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }